import React, { useState, useEffect } from 'react';
import { Switch, Route, Link, useLocation, Redirect } from 'react-router-dom';
import SettingsBasicInfo from './SettingsBasicInfo';
import SettingsDepop from './SettingsDepop';
import SettingsBilling from './SettingsBilling';
import '../../../styles/dashboard/settings/DashboardSettings.css';

export default function DashboardSettings() {
    const location = useLocation();

    const nav = {
        basicinfo: "Basic Information",
        depop: "Depop Account",
        billing: "Billing Settings"
    };

    const [activeTab, setActiveTab] = useState('basicinfo');
    
    useEffect(() => {
        const locSplit = location.pathname.split('/');
        const currentTab = locSplit[locSplit.length - 1];
        setActiveTab(currentTab);
    }, [location]);

    return (
        
        <div className="DashboardSettings">
            <div className="header">
                <h1>Your Settings</h1>
            </div>
            <ul>
                {
                    Object.keys(nav).map(tab => {
                        if (tab === activeTab) {
                            return (
                                <li>
                                    <div className="active">&nbsp;</div>
                                    <Link 
                                    id={tab}
                                    onClick={(e) => setActiveTab(e.target.id)}
                                    className={activeTab === tab ? "active" : ""}
                                    to={`/dashboard/settings/${tab}`}>{nav[tab]}</Link>
                                </li>
                            )
                        }
                        else {
                            return (
                                <li>
                                    <Link 
                                    id={tab}
                                    onClick={(e) => setActiveTab(e.target.id)}
                                    className={activeTab === tab ? "active" : ""}
                                    to={`/dashboard/settings/${tab}`}>{nav[tab]}</Link>
                                </li>
                            )                            
                        }

                    })
                }
                
            </ul>
            <hr/>
            <div className="content">
                <Switch>
                    <Route
                    exact
                    path="/dashboard/settings"
                    render={(props) =>
                        <Redirect
                        to={{
                            pathname: '/dashboard/settings/basicinfo',
                            state: { from: props.location }
                        }} /> 
                    } />
                    <Route 
                    exact
                    path="/dashboard/settings/basicinfo"
                    component={SettingsBasicInfo} />
                    <Route
                    exact
                    path="/dashboard/settings/depop"
                    component={SettingsDepop} />
                    <Route
                    exact 
                    path="/dashboard/settings/billing"
                    component={SettingsBilling} />
                </Switch>                     
            </div>

        </div>
    )
}